/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Enum for invitation status
 */
export var InvitationStatus;

(function (InvitationStatus) {
  InvitationStatus["PENDING"] = "pending";
  InvitationStatus["ACCEPTED"] = "accepted";
})(InvitationStatus || (InvitationStatus = {}));